import React, { useRef } from "react";
import { getAccessStateValue, NO_ACCESS_TEXT } from "../../App/App";
import AttackSurfaceTooltip from "../../AttackSurface/AssetsList/AttackSurfaceTooltip";
import { Button } from "react-bootstrap";

const CompanySettingsHeader = ({
  selectedImage,
  accessStateValue = 'AccessState_MSP_System_Settings',
  onImageChang = (e) => { },
  onImageRemove = () => { },
  isView = false,
}) => {
  const fileUpload = useRef();
  const isReadOnly = isView || getAccessStateValue(accessStateValue) < 3;

  return (
    <>
      <h3 className="m-0">Company settings</h3>
      <input
        type="file"
        accept="image/*"
        ref={fileUpload}
        className="d-none"
        onChange={(e) => { onImageChang(e) }}
      />
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-16">
        <img className="rounded-circle border-grey camera-icon cursor-pointer"
          src={selectedImage ? selectedImage : "https://st4.depositphotos.com/1012074/20946/v/450/depositphotos_209469984-stock-illustration-flat-isolated-vector-illustration-icon.jpg"}
          alt=""
          width="79"
        />

        <AttackSurfaceTooltip
          disabled={!isReadOnly}
          bottomLeft={true}
          topLeft={false}
          content={<span>{NO_ACCESS_TEXT}</span>}
        >
          <div className="d-flex align-items-center" style={{ pointerEvents: isReadOnly ? "none" : "all" }}>
            {isReadOnly && (
              <img width={14} height={14} alt="" src="/images/attack-surface/small-lock.svg" className="mr-2" />
            )}

            {selectedImage ? (
              <div>
                <Button className="change-photo-btn" onClick={() => { fileUpload.current.click(); }}>
                  Change logo
                </Button>
                <Button className="remove-photo-btn" onClick={onImageRemove}>
                  Remove logo
                </Button>
              </div>
            ) : (
              <Button className="profile-upload-btn" onClick={() => { fileUpload.current.click(); }}>
                Upload logo
              </Button>
            )}
          </div>
        </AttackSurfaceTooltip>
      </div>
    </>
  );
};

export default CompanySettingsHeader;
